











import {Component, Prop, Vue} from 'vue-property-decorator';
import {QuickLink, QuickLinkType} from '../../../../build/swagger-code-extranet-api-definition';
import QuickLinksStoreModule from '../../../store/modules/quickLinks.module';
import {getModule} from 'vuex-module-decorators';

@Component
export default class BudgetOrdersQuickLinkItem extends Vue {
    @Prop({required: true}) private item: QuickLink;
    @Prop({required: true}) private color: string;

    private store: QuickLinksStoreModule = getModule(QuickLinksStoreModule, this.$store);

    get isImage() {
        return this.item.iconType === QuickLinkType.IMAGE;
    }

    get iconSource() {
        return require('../../../assets/' + this.item.iconName);
    }

    get badgeCount() {
        return this.store.budgetOrdersCount;
    }
}
